const EPS = 0.01;
// A run counts for the Hook if it starts at or up to one bar after the Hook line: a ruler
// click or Show me lands a little past the exact bar.
const HOOK_START_TOLERANCE = 1;

export function createClassPlaybackTracker(progress = {}) {
  return {
    running: false,
    paused: false,
    runStart: null,
    lastBar: null,
    looped: false,
    heardHook: progress.heardHook === true,
    listenedThrough: progress.listenedThrough === true,
  };
}

function result(state, changed = {}) {
  return { state, changed };
}

export function updateClassPlaybackTracker(previous, event, { hookStart, mapLength, loopEnabled = false } = {}) {
  const state = { ...previous };
  const bar = Number(event.bar);
  if (event.type === 'play') {
    const canResume = state.paused && Number.isFinite(bar) && Math.abs(bar - state.lastBar) <= EPS;
    state.running = true;
    state.paused = false;
    if (!canResume) {
      state.runStart = bar;
      state.looped = Boolean(loopEnabled);
    } else if (loopEnabled) state.looped = true;
    state.lastBar = bar;
    return result(state);
  }
  if (event.type === 'pause') {
    if (state.running) { state.running = false; state.paused = true; }
    return result(state);
  }
  if (event.type === 'seek' || event.type === 'jump' || event.type === 'stop') {
    state.running = false;
    state.paused = false;
    state.runStart = null;
    state.looped = false;
    state.lastBar = Number.isFinite(bar) ? bar : null;
    return result(state);
  }
  if (event.type !== 'tick' || !state.running || !Number.isFinite(bar)) return result(state);
  if (state.lastBar !== null && bar + EPS < state.lastBar) {
    state.running = false;
    state.paused = false;
    state.runStart = null;
    state.lastBar = bar;
    return result(state);
  }
  const changed = {};
  state.lastBar = bar;
  if (loopEnabled) state.looped = true;
  if (!state.heardHook && state.runStart <= Number(hookStart) + HOOK_START_TOLERANCE && bar >= Number(hookStart) + 4) {
    state.heardHook = true;
    changed.heardHook = true;
  }
  if (!state.listenedThrough && state.runStart < 1 && !state.looped && bar >= Number(mapLength) - 0.25) {
    state.listenedThrough = true;
    changed.listenedThrough = true;
  }
  return result(state, changed);
}
